// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".crop-image[data-v-2f721dfe] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 220px;\n  background: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 8px;\n}\n.crop-image__img[data-v-2f721dfe] {\n  display: block;\n  width: auto;\n  height: auto;\n}\n.crop-image__placeholder[data-v-2f721dfe] {\n  color: #64748b;\n}\n", ""]);
// Exports
module.exports = exports;
